import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Clouds from "./Clouds";
import Homepage from "./Homepage";
import LinkInBio from "./LinkInBio";
import CovidMasks from "./CovidMasks";
import "../style/style.scss";

const App = () => {
  const Footer = () => {
    return (
      <footer className="footer">
        <span>
          Copyright &copy; {new Date().getYear() + 1900} Abigail Christens. All
          rights reserved.
        </span>
      </footer>
    );
  };

  return (
    <Router>
      <Clouds />
      <div className="app">
        <nav>
          <ul className="navList">
            <li>
              <Link to="/">HOME</Link>
            </li>
            <li>
              <a href="mailto:hello@abigailchristens.com">CONTACT</a>
            </li>
          </ul>
        </nav>

        <Switch>
          <Route path="/linkinbio">
            <LinkInBio />
          </Route>
          <Route path="/shop">
            <CovidMasks />
          </Route>
          <Route path="/">
            <Homepage />
          </Route>
        </Switch>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
